import React from 'react';

import moment from 'moment';

import findKey from 'lodash/findKey';

import {
	locale as affiliateRegistrationSourcesLocale,
	enum as affiliateRegistrationSources
} from '../../../../../enums/affiliate-registration-sources';

function renderSource({ value }, { intl }) {
	const key = findKey(affiliateRegistrationSources, id => id === value);
	return affiliateRegistrationSourcesLocale[intl.language][key] || '-';
}

function renderAnswers({ value }) {
	return !value ? '-' : value.map((m) => (
		<div key={m.id}>
			{!!m.text && (
				<div>{m.text}</div>
			)}
			{!!m.filePath && (
				<a href={m.filePath} target='_blank'>{m.filePath}</a>
			)}
		</div>
	));
}

export default [
	[
		{
			index: 'date',
			header: {
				title: 'date'
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'manager',
			header: {
				title: 'manager'
			},
			column: {}
		},
		{
			index: 'id',
			header: {
				title: 'id'
			},
			column: {}
		},
		{
			index: 'email',
			header: {
				title: 'email'
			},
			column: {}
		},
		{
			index: 'telegram',
			header: {
				title: 'telegram'
			},
			column: {}
		},
		{
			index: 'source',
			header: {
				title: 'source'
			},
			column: {
				render: renderSource
			}
		},
		{
			index: 'utm_source',
			header: {
				title: 'UTM source'
			},
			column: {}
		},
		{
			index: 'answers',
			header: {
				title: 'answers'
			},
			column: {
				className: 'registration-analytics-answers',
				render: renderAnswers
			}
		},
		{
			index: 'decision',
			header: {
				title: 'decision'
			},
			column: {
				format: v => v === 'approved' ? '✅' : '❌'
			}
		},
		{
			index: 'is_active',
			header: {
				title: 'active'
			},
			column: {
				format: v => v ? '✅' : '❌'
			}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/registration-analytics/table-initial-data.js